//IApplauded.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';

const IApplaudedForMarksheet = () => {
  const location = useLocation();
  const authState = useSelector(state => state.authReducer);
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [applauses, setApplauses] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [selectedApplauseId, setSelectedApplauseId] = useState(null);
  const fetchApplauses = useCallback(async () => {
    if (!authState.isLoggedIn) return;

    const config = {
      url: "/applause/marksheet", 
      method: "post",
      headers: { Authorization: authState.token },
      data: { userId: authState.user._id }
    };

    try {
      const data = await fetchData(config, { showSuccessToast: false });
      setApplauses(data.applauses);
    } catch (error) {
      console.error('Error fetching applauses:', error);
    }
  }, [authState.token, authState.user._id, authState.user.thin5whyscode, authState.isLoggedIn, fetchData, setApplauses]);

  useEffect(() => {
    fetchApplauses();
  }, [fetchApplauses]);

  const [isDeleteClicked, setIsDeleteClicked] = useState(false);
  const deleteClicked = () => {
    setIsDeleteClicked(true);
  }
  
  const noDeleteClicked = () => {
    setIsDeleteClicked(false);
  }
  
  const handleDelete = (id) => {
    const config = {
      url: `/applause/${id}`,
      method: "delete",
      headers: { Authorization: authState.token }
    };
    fetchData(config).then(() => fetchApplauses());
  }

  const handleView = (applauseId) => {
    setSelectedApplauseId(prevId => (prevId === applauseId ? null : applauseId));
  };

  const handleCloseApplauseDetails = () => {
    setSelectedApplauseId(null);
  };

  const handleApplauseClick = (ApplauseId) => {
    setSelectedApplauseId(ApplauseId);
  };

  const handleApplauseShare = (ApplauseId) => {
    setSelectedApplauseId(ApplauseId);
  };

  const handleApplauseSave = (ApplauseId) => {
    setSelectedApplauseId(ApplauseId);
  };

  const handleApplausePrint = (ApplauseId) => {
    setSelectedApplauseId(ApplauseId);
  };

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

  const sortedApplauses = [...applauses].sort((a, b) => new Date(b.applauseDate) - new Date(a.applauseDate));

  return (
    <div className="min-h-screen bg-black py-8">
      <div className='border-b border-blue-400 '>
        <h2 className="text-lg lg:text-xl font-bold text-yellow-200 text-center mb-2">
          📃👍 Applause for Marksheet
        </h2>
      </div>      
      <div className="my-2 mx-auto py-2">
        <div className="p-2 mt-2">
          <div className="mt-2">
            {/* <div className="mt-2 mb-2"> */}
              {applauses && applauses.length !== 0 && (
                <div className="flex justify-between items-center border-b border-b-gray-300 mb-2 py-2">
                  <div>
                    <h3 className='text-m lg:text-lg mt-1 mx-2 text-white'>{applauses.length} Applauses on Marksheet By You Found!</h3>
                  </div>
                  <div className='mr-4'>
                    <Link to='/applause/marksheet/add' className='block w-full h-full px-1 py-2 ml-4 bg-blue-500 rounded-md text-sm lg:text-m'>
                      <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />Add New
                    </Link>
                </div>
              </div>
              )}
            {/* </div> */}
          </div>
          {loading ? (
            <Loader />
          ) : (
            <div>
              {applauses && applauses.length === 0 ? (
                <div className='h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                  <div className="flex justify-between items-center">
                  <div>
                  <h3 className='text-xl mt-1 mx-2 text-orange-400'>No Applause Record Found!</h3>
                  </div>
                  <div>
                  <Link to='/applause/marksheet/add' className='block w-full h-full px-1 py-2 ml-4 bg-blue-500 rounded-md'>
                    <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Add New
                  </Link>
                </div>
              </div>
                </div>
              ) : (
                sortedApplauses.map((applause, index) => (
                  <div key={applause._id} className='bg-black my-4 p-4 border border-gray-500 text-white rounded-md shadow-md'>
                    <div className='flex'>
                      {/* <span className='font-medium'> */}
                          <span className=' text-sm lg:text-m'>#{index + 1} {'To '}</span>
                          <span className='text-blue-500 mr-2 ml-2 text-sm lg:text-m'>{applause.applauseTo}</span>
                            {' '}
                          <span className='text-green-600 mr-2 text-sm lg:text-m'>{applause.name}</span>
                          <span className='text-sm lg:text-m'>{'On '}{formatDateTime(applause.applauseDate)}</span>
                        {/* </span> */}
                      <Tooltip text={"View details"} position={"top"}>
                        <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(applause._id)}>
                          <i className="fa-solid fa-eye"></i>
                        </span>
                      </Tooltip>
                      <Tooltip text={"Edit this record"} position={"top"}>
                        <Link to={`/applause/marksheet/${applause._id}`} className='mr-4 text-green-600 cursor-pointer'>
                          <i className="fa-solid fa-pen"></i>
                        </Link>
                      </Tooltip>
                    </div>
                    {selectedApplauseId === applause._id && (
                      <div className='bg-black text-white border border-gray-400 px-4 py-2'>
                        <h2 className='text-blue-600'><strong>You Applauded To: </strong>{applause.applauseTo}{' '}{applause.name}</h2>
                        <p><strong>Exam Name:</strong> {applause.title}</p>
                        <p><strong>School / College / Board / University:</strong> {applause.school}</p>
                        <p><strong>Student Name:</strong> {applause.student}</p>
                        {applause.applauseTo === "Parent" && (
                          <p><strong>Profession:</strong> {applause.profession}</p>
                        )}
                        <p><strong>Overall % Marks Obtained:</strong> {applause.overallMarks}</p>
                        <p><strong>Favourite Subject:</strong> {applause.favSubject}</p>
                        <p><strong>% Marks in the Subject:</strong> {applause.subjectMarks}</p>     
                        <p><strong>Date:</strong> {formatDateTime(applause.dateMarksheet)}</p>
                        <p><strong>Description:</strong> {applause.description}</p>     
                        <p><strong>Influencer Think5Whys Code:</strong> {applause.influencerCode}</p>
                        <p><strong>Instagram Id:</strong> {applause.instagramId}</p>
                        <p><strong>Date Applauded:</strong> {formatDateTime(applause.applauseDate)}</p>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
      <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
        <div className="flex flex-wrap gap-4 text-sm">
          <Link to="/about-us" className="hover:text-teal-300">About</Link>
          <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
          <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
          <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
        </div>
      </div>
    </footer>      
  </div>
  )
}

export default IApplaudedForMarksheet;
